import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowDown, Crosshair } from "lucide-react";
export default function EngineeringPrecisionForIndustrialProgress() {
  return <section data-section-id="224938" id="singapore-time-innovation-investment-holding-group" className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col justify-center">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes scan {
            0% { top: -10%; opacity: 0; }
            10% { opacity: 1; }
            90% { opacity: 1; }
            100% { top: 110%; opacity: 0; }
          }
          @keyframes border-pulse {
            0% { box-shadow: 0 0 0 0 rgba(var(--color-primary-rgb), 0.4); }
            70% { box-shadow: 0 0 0 15px rgba(var(--color-primary-rgb), 0); }
            100% { box-shadow: 0 0 0 0 rgba(var(--color-primary-rgb), 0); }
          }
          .animate-scan {
            animation: scan 6s linear infinite;
          }
          .animate-border-pulse {
            animation: border-pulse 2s infinite;
          }
        `
    }} />

      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/singapore_marina_skyline.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/singapore_marina_skyline.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/singapore_marina_skyline.png-wvc-sizes" alt="Singapore Marina Skyline" className="absolute inset-0 w-full h-full object-cover" width="1920" height="1080" loading="eager" fetchPriority="high" />
        <div className="absolute inset-0 bg-black/15" />
        {}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)]" />
      </div>

      {}

      {}
      <div className="container relative z-20 mx-auto px-4 md:px-8 h-full flex flex-col justify-center">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 items-center">
          
          {}
          <div className="lg:col-span-3 hidden md:flex flex-col items-start justify-end h-full">
            <div className="relative w-full max-w-[240px] flex items-center justify-center -translate-y-16 translate-x-16 mr-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/11.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/11.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651741/img/11.png-wvc-sizes" alt="STI Group Logo" className="object-contain !border-1 border-[rgb(14,22,37)] !border-none !opacity-[0.83] !text-[rgba(14,22,37,1)] !p-0 !m-0 !h-[410px] !w-[290px] !bg-transparent" width="290" height="410" loading="eager" fetchPriority="high" />
            </div>
          </div>

          {}
          <div className="lg:col-span-9 flex flex-col items-start">
            {}
            <h1 className="font-default font-bold text-[clamp(2.5rem,5vw,5.5rem)] leading-[0.95] tracking-tighter text-foreground drop-shadow-2xl mb-8 uppercase max-w-[18ch]">
              Singapore Time Innovation Investment Holding Group
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mb-12 font-default font-light border-l-2 border-primary pl-6">
              A diversified multinational investment holding group driving global industrial transformation through capital innovation and strategic resource networks across Asia and beyond.
            </p>

            <div className="relative group">
              {}
              <div className="absolute -inset-1 bg-primary/10 animate-ping opacity-10" />
              <div className="absolute inset-0 border border-primary/30 animate-border-pulse pointer-events-none" />
              
              <Button asChild size="lg" className="relative bg-background/40 backdrop-blur-xl border border-primary/40 text-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-500 h-16 px-10 text-lg font-mono tracking-wider uppercase">
                <Link to="/GroupSectionPage">
                  Group sector
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center justify-center z-20 opacity-60 hover:opacity-100 transition-opacity cursor-pointer">
        <div className="w-[1px] h-16 bg-gradient-to-b from-transparent via-primary/30 to-primary mb-2" />
        <div className="relative">
          <ArrowDown className="size-6 text-primary animate-bounce" />
          {}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 border border-primary/20 rotate-45 rounded-sm" />
        </div>
        <span className="mt-4 font-mono text-[10px] tracking-[0.3em] text-primary uppercase">Scroll Down</span>
      </div>
    </section>;
}